import React, { Component } from 'react';

const title = "Connect with Your Soul Mate on Tegal";
const subtitle = "Marriage is our greatest adventure";
const desc="Tegal is a premier matchmaking service dedicated to connecting individuals from diverse backgrounds, tribes, and religions for meaningful relationships that lead to marriage. It fosters a vibrant community that celebrates love, diversity, and unity.  We believe that meaningful relationships start with genuine conversations and shared interests. Our platform is designed to help you find your perfect partner if you\'re looking for a marriage";


class MemberSection extends Component {
    render() { 
        return (
            <section className="member-section padding-tb">
                <div className="container">
                    <div className="section-header">
                        <h4 className="theme-color">{subtitle}</h4>
                        <h2>{title}</h2>
                        <p>{desc}</p>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default MemberSection;